"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(rows, id, filterValue) {
  if (!filterValue.length) return rows;
  return rows.filter(function (row) {
    for (var i = 0; i < filterValue.length; i++) {
      var _filterValue$i = filterValue[i],
          min = _filterValue$i.min,
          max = _filterValue$i.max;
      if (row.values.date.isBetween(min, max)) return true;
    }

    return false;
  });
};

exports.default = _default;